/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useState } from 'react';
import JSONTree from 'react-json-tree';
import { ActionButton } from '@blend/enterprise-components';
import { LoneIconButton } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  copyButtonValue: {
    bottom: '-5px',
    display: 'none',
    paddingLeft: '10px',
    position: 'absolute',
  },
  value: {
    ':hover': { color: 'red' },
    ':hover > span:last-child': { display: 'inline' },
    position: 'relative',
  },
});

export namespace JSONTreeView {
  export interface Props {
    data: any;
  }
}

export const JSONTreeView: React.FC<JSONTreeView.Props> = ({ data }) => {
  const [expandAll, setExpandAll] = useState<boolean>(false);

  const onClick = () => setExpandAll(prevState => !prevState);
  const expandButtonLabel = () => (expandAll ? 'Collapse all nodes' : 'Expand all nodes');

  const valueRendererFunction = (raw: string | number) => {
    const textWithoutQuotes = typeof raw === 'string' ? raw.replace(/['"]+/g, '') : raw.toString();
    return (
      <span className={css(styles.value)}>
        <span>{textWithoutQuotes}</span>
        <span className={css(styles.copyButtonValue)}>
          <LoneIconButton
            btnSize="xs"
            icon="content_copy"
            iconSize={14}
            onClick={() => navigator.clipboard.writeText(textWithoutQuotes)}
            theme="light"
          />
        </span>
      </span>
    );
  };

  const handleItemCopyButton = (e: React.MouseEvent, data: Object) => {
    // Overrides parent's click action i.e., expanding and collapsing the tree.
    e.stopPropagation();
    navigator.clipboard.writeText(JSON.stringify(data));
  };

  return (
    <div id="it-json-tree">
      <JSONTree
        data={data}
        getItemString={(_type, data, itemType, itemString, _keyPath) => (
          <span className={css(styles.value)}>
            {itemType} {itemString}
            <span className={css(styles.copyButtonValue)}>
              <LoneIconButton
                btnSize="xs"
                icon="content_copy"
                iconSize={14}
                onClick={e => handleItemCopyButton(e, data)}
                theme="light"
              />
            </span>
          </span>
        )}
        invertTheme={true}
        shouldExpandNode={() => expandAll}
        valueRenderer={valueRendererFunction}
      />
      <ActionButton label={expandButtonLabel()} onClick={onClick} theme="primary" />
    </div>
  );
};
